// extracted by mini-css-extract-plugin
module.exports = {"tabUnread":"__3_Tuz9fI","wrap":"avvEUv43","empty":"WGwbRoxb","item":"__31Gb_SzM","unread":"lJIdVNDW","time":"y9IVtAU_","avatar":"ikW_X5Ad","info":"cDRdEsUZ","pinview":"DXMT5SnL"};